import { render, staticRenderFns } from "./KioskSettings.vue?vue&type=template&id=5ed62e54&scoped=true"
import script from "./KioskSettings.vue?vue&type=script&lang=js"
export * from "./KioskSettings.vue?vue&type=script&lang=js"
import style0 from "./KioskSettings.vue?vue&type=style&index=0&id=5ed62e54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed62e54",
  null
  
)

export default component.exports